import React, { useState } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DownloadPdf from './pdf/DownloadPdf';

function  DownloadPDF  (props){

 const DownloadDocument = () => {
        const input = document.getElementById('printdiv');
        html2canvas(input)
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            pdf.addImage(imgData, 'JPEG', 0, 0);
            //pdf.output('dataurlnewwindow');
            pdf.save("TransferConfirmation.pdf");
          })
        ;
       }
    return(

    <Modal  
        show={props.show}             
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered 
        backdrop="static"
        onHide={props.onHide}
        >
        <div id="printdiv">
            <Modal.Header closeButton>
                <Modal.Title className='modal-t' id="contained-modal-title-vcenter">            
                <div className='modal-t'>
                    <img className="profile-img2" src={require('../images/logo.png')} alt="logo"/>
                    <font color="black">SENKADAGALA FINANCE PLC</font>
                </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Form >
            <p className='t-center form-h2'>Payment has been completed</p>
            <p className='t-center form-h2 s-top'>SENDER DETAILS</p>
            <div className='row mb-0'>
                <div className='col-lg-6 col-12'>
                    <div className='row'>
                        <div className='col-lg-6 col-6'>
                            <p className='form-h2 t-width1'>Account Number</p>
                        </div>
                        <div className='col-lg-6 col-6'>
                            <p className='form-h2'>{props.senderAccount}</p>
                        </div>
                    </div>
                </div>
                <div className='col-lg-6 col-12'>
                    <div className='row'>
                        <div className='col-lg-6 col-6'>
                            <p className='form-h2 t-right t-width3 w-full'>Date</p>
                        </div>
                        <div className='col-lg-6 col-6'>
                            <p className='form-h2 t-right  t-width3 w-full'>{props.paydate}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row mb-4'>
                <div className='col-lg-6 col-12'>
                    <div className='row'>
                        <div className='col-lg-6 col-6'>
                            <p className='form-h2 t-width1'>Name</p>
                        </div>
                        <div className='col-lg-6 col-6'>
                            <p className=' form-h2'>{props.senderName}</p>
                        </div>
                    </div>
                </div>
            </div>
            <p className='t-center form-h2 s-top'>PAYMENT DETAILS</p>  
            <div className='d-flex flex-column align-items-center s-top justify-content-center'>
                <div className='d-flex flex-row'>
                    <p className=' form-h2 t-width1'>Reference Number</p>
                    <p className='t-width2 form-h2'>{props.refNum}</p>
                </div> 
                <div className='d-flex flex-row s-top'>
                    <p className='form-h2 t-width1'>Name</p>
                    <p className='t-width2 form-h2'>{props.beneName}</p>
                </div>  
                <div className='d-flex flex-row s-top'>
                    <p className=' form-h2 t-width1'>Bank</p>
                    <p className='t-width2 form-h2'>{props.bank}</p>
                </div> 
                <div className='d-flex flex-row s-top'>
                    <p className=' form-h2 t-width1'>Branch</p>
                    <p className='t-width2 form-h2'>{props.branch}</p>
                </div> 
                <div className='d-flex flex-row s-top'>
                    <p className=' form-h2 t-width1'>Account Number</p>
                    <p className='t-width2 form-h2'>{props.beneAccount}</p>
                </div>
                <div className='d-flex flex-row s-top'>
                    <p className='form-h2 t-width1'>Payment Amount Rs.</p>
                    <p className='t-width2 form-h2'>{props.amount}</p>
                </div>
                <div className='d-flex flex-row s-top'>
                    <p className='form-h2 t-width1'>Bene. Reference</p>
                    <p className='t-width2 form-h2'>{props.bankRef}</p>
                </div>
                
                {props.children}  
            </div>   
                
            </Form>                                   
            </Modal.Body>
        </div>
        <Modal.Footer className="d-flex s-top justify-content-center"> 
            <PDFDownloadLink document={<DownloadPdf data={props}/>} fileName="TransferConfirmation.pdf">
                <Button type="button" className="btn-logout " >DOWNLOAD</Button>
            </PDFDownloadLink>
        </Modal.Footer>   
        </Modal>
    );
}
export default DownloadPDF;